import React, { useReducer } from 'react';
import styled from "styled-components";
import Text from "../Text";
import IconBtn from "../IconBtn";
import Tx from "../Tx";
import { generateRandomName } from "../../utils";
import ImageSelectController from './ImageSelectController';

const WrapperStyled = styled.div`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(231, 235, 240);
  padding: 10px;
`;

const FloorEditPanelStyled = styled.div`
  width: 200px;
  display: inline-block;
`;

const ActionsPanelStyled = styled.div`
  width: 100px;
  display: inline-block;
  margin-left: 10px;
`;

const TickEditPanelStyled = styled.div`
  width: 70px;
  display: inline-block;
  margin-left: 10px;
`;

const SecondaryActionsPanelStyled = styled.div`
  display: inline-block;
  margin-left: 10px;
  position: relative;
  top: 14px;
`;

const KnnsStyled = styled.div`
  display: inline-block;
  margin-left: 20px;
`;

const KnnItemStyled = styled.div`
  display: inline-block;
  margin: 0 0 10px 10px;
  border: rgba(0, 0, 0, 0.23) 1px solid;
  border-radius: 4px;
  padding: 4px;
`;

const MiniHrStyled = styled.div`
  margin: 0 5px;
  background: rgba(0, 0, 0, 0.23);
  width: 1px;
  height: 25px;
  display: inline-flex;
  vertical-align: middle;
`;

const CheckStyled = styled.div`
  display: inline-block;
  margin-bottom: 5px;
`;


const ActionsPanel = (props) => {
    const {
        tick,
        s_tick,
        floor_width,
        s_floor_width,
        floor_height,
        s_floor_height,
        onLongMoveHandle,
        onLongRotateHandle,
        moveIntervalId,
        rotateIntervalId,
        floor_selected_item,
        move,
        mirror,
        rotate,
        s_floor_selected_item,
        setSelectedFactors,
        removeFromFloor,
        isSensorSelected,
        editSensorMute,
        testSensorHandle,
        show_knns,
        s_show_knns,
        show_camera,
        s_show_camera,
        show_fields,
        s_show_fields,
        show_steps,
        s_show_steps,
        s_check_in_display,
        check_in_display,
        check_in_rect,
        s_check_in_rect,
        s_check_in_draw_mode,
        s_check_out_display,
        check_out_display,
        check_out_rect,
        s_check_out_rect,
        s_check_out_draw_mode,
        knns,
        s_knns,
        s_knnsDraModeIndex,
        selectedImage,
        setSelectedImage,
        selectedSiteType
    } = props;

    const [imagePickerVisible, toggleImagePickerVisible] = useReducer(prev => !prev, false);

    const arrowsData = [
        {
            vector: "left",
            value: "circleArrowLeft"
        },
        {
            vector: "up",
            value: "circleArrowUp"
        },
        {
            vector: "down",
            value: "circleArrowDown"
        },
        {
            vector: "right",
            value: "circleArrowRight"
        }
    ];

    return (
        <WrapperStyled>
            <FloorEditPanelStyled>
                <Text
                    label="floor.width"
                    type="number"
                    value={floor_width}
                    onChange={s_floor_width} />
            </FloorEditPanelStyled>
            <ActionsPanelStyled>
                <Text
                    label="floor.height"
                    type="number"
                    value={floor_height}
                    onChange={s_floor_height} />
            </ActionsPanelStyled>
            <TickEditPanelStyled>
                <Text
                    label="Tick"
                    type="number"
                    value={tick}
                    onChange={(val) => s_tick(Number(val))} />
            </TickEditPanelStyled>

            <SecondaryActionsPanelStyled style={{ marginBottom: 24 }}>
                <IconBtn onClick={toggleImagePickerVisible}>imageIcon</IconBtn>
                <ImageSelectController
                    isVisible={imagePickerVisible}
                    onClose={toggleImagePickerVisible}
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                />
                <MiniHrStyled />

                <IconBtn
                    disabled={floor_selected_item === -1}
                    style={{ marginLeft: 2 }}
                    size="small"
                    onClick={mirror}
                >
                    lowPriorityIcon
                </IconBtn>

                {arrowsData.map(arrow => {
                    return (
                        <IconBtn
                            onMouseDown={(e) => {
                                onLongMoveHandle(e, arrow.vector);
                            }}
                            onMouseUp={() => {
                                moveIntervalId && clearInterval(moveIntervalId);
                            }}
                            key={arrow.value}
                            disabled={floor_selected_item === -1}
                            style={{ marginLeft: 2 }}
                            size="small"
                            onClick={e => move(arrow.vector, e)}
                        >
                            {arrow.value}
                        </IconBtn>
                    );
                })}

                <IconBtn
                    disabled={floor_selected_item === -1}
                    style={{ marginLeft: 2 }}
                    size="small"
                    onClick={e => rotate('right', e)}
                    onMouseDown={(e) => {
                        onLongRotateHandle(e);
                    }}
                    onMouseUp={() => {
                        rotateIntervalId && clearInterval(rotateIntervalId);
                    }}
                >
                    rotateRight
                </IconBtn>


                <IconBtn disabled={floor_selected_item === -1} onClick={() => { s_floor_selected_item(-1); setSelectedFactors(); }}
                    style={{ marginLeft: 2 }}
                    size="small">deselect</IconBtn>

                <IconBtn disabled={floor_selected_item === -1} onClick={() => { removeFromFloor(); setSelectedFactors(); }}
                    style={{ marginLeft: 2 }}
                    size="small">delete</IconBtn>
                {isSensorSelected && (
                    <>
                        <IconBtn disabled={floor_selected_item === -1}
                            onClick={() => {
                                editSensorMute();
                            }}
                            style={{ marginLeft: 2 }}
                            size="small">
                            {isSensorSelected?.sensor?.mute ? 'volumeMuteIcon' : 'volumeOffIcon'}
                        </IconBtn>
                        <IconBtn disabled={floor_selected_item === -1}
                            onClick={() => {
                                testSensorHandle();
                            }}
                            style={{ marginLeft: 2 }}
                            size="small">
                            scienceIcon
                        </IconBtn>
                    </>
                )}
                <MiniHrStyled />
                <IconBtn
                    label={`${show_knns ? 'Hide' : "Show"} Knn`}
                    style={{ marginLeft: 8 }}
                    size="small"
                    onClick={() => {
                        s_show_knns(!show_knns);
                    }}>
                    {show_knns ? 'eyeOff' : 'eye'}
                </IconBtn>
                <IconBtn
                    label={`${show_camera ? 'Hide' : "Show"} Camera`}
                    style={{ marginLeft: 8 }}
                    size="small"
                    onClick={() => {
                        s_show_camera(!show_camera);
                    }}>
                    {show_camera ? 'eyeOff' : 'eye'}
                </IconBtn>
                <IconBtn
                    label={`${show_fields ? 'Hide' : "Show"} Field`}
                    style={{ marginLeft: 8 }}
                    size="small"
                    onClick={() => {
                        s_show_fields(!show_fields);
                    }}>
                    {show_fields ? 'eyeOff' : 'eye'}
                </IconBtn>
                <IconBtn
                    label={`${show_steps ? 'Hide' : "Show"} Steps`}
                    style={{ marginLeft: 8 }}
                    size="small"
                    onClick={() => {
                        s_show_steps(!show_steps);
                    }}>
                    {show_steps ? 'eyeOff' : 'eye'}
                </IconBtn>
            </SecondaryActionsPanelStyled>

            {selectedSiteType !== 'Inventory' && (
                <div>
                    <CheckStyled>
                        <Tx>floor.checkin</Tx>
                        <IconBtn style={{ marginLeft: 8 }} size="small"
                            onClick={() => s_check_in_display(!check_in_display)}>{check_in_display ? 'eye' : 'eyeOff'}</IconBtn>
                        <IconBtn style={{ marginLeft: 2 }} size="small" disabled={!check_in_rect.length}
                            onClick={() => s_check_in_rect([])}>delete</IconBtn>
                        <IconBtn style={{ marginLeft: 2 }} size="small" onClick={() => {
                            s_check_in_rect([]);
                            s_check_in_display(true);
                            s_check_in_draw_mode(true);
                        }}>draw</IconBtn>
                    </CheckStyled>
                    <CheckStyled style={{ marginLeft: 20 }}>
                        <Tx>floor.checkout</Tx>
                        <IconBtn style={{ marginLeft: 8 }} size="small"
                            onClick={() => s_check_out_display(!check_out_display)}>{check_out_display ? 'eye' : 'eyeOff'}</IconBtn>
                        <IconBtn style={{ marginLeft: 2 }} size="small" disabled={!check_out_rect.length}
                            onClick={() => s_check_out_rect([])}>delete</IconBtn>
                        <IconBtn style={{ marginLeft: 2 }} size="small" onClick={() => {
                            s_check_out_rect([]);
                            s_check_out_display(true);
                            s_check_out_draw_mode(true);
                        }}>draw</IconBtn>
                    </CheckStyled>
                    <KnnsStyled>
                        <Tx>Knn</Tx>
                        <div style={{ display: 'inline-block' }}>
                            <IconBtn style={{ marginLeft: 8 }} size="small" onClick={() => {
                                const tempKnn = [...knns];

                                tempKnn.push({
                                    knnName: generateRandomName(),
                                    area: {
                                        xMin: 0,
                                        yMin: 0,
                                        xMax: 0,
                                        yMax: 0
                                    }
                                });
                                s_show_knns(true);
                                s_knns(tempKnn);
                            }}>addCircleIcon</IconBtn>
                        </div>

                        {knns.map((item, idxx) => {
                            return (
                                <KnnItemStyled key={"knn" + idxx}>
                                    <span>{item.knnName}</span>
                                    <IconBtn style={{ marginLeft: 2 }} size="small"
                                        onClick={() => {
                                            const temp = [...knns];
                                            temp.splice(idxx, 1);
                                            s_knns(temp);
                                        }}
                                    >delete</IconBtn>
                                    <IconBtn style={{ marginLeft: 2 }} size="small" onClick={() => {
                                        s_show_knns(true);
                                        s_knnsDraModeIndex(idxx);
                                        const tempKnn = [...knns];
                                        tempKnn[idxx].area.xMax = 0;
                                        tempKnn[idxx].area.yMax = 0;
                                        tempKnn[idxx].area.xMin = 0;
                                        tempKnn[idxx].area.xMin = 0;
                                        s_knns(tempKnn);
                                    }}>draw</IconBtn>
                                </KnnItemStyled>
                            );
                        })}
                    </KnnsStyled>
                </div>
            )}
        </WrapperStyled>
    );
};

export default ActionsPanel;